import React, { useMemo } from 'react';
import { useEngineInstance } from '@surveycake/react-logic-engine';
import { useSurveyConfig } from 'app/core/survey-config';
import PreviewAnswer from './PreviewAnswer';
import PostAnswer from './PostAnswer';
import * as styles from './styles';

export default function Submit() {
  const engine = useEngineInstance();
  const previewAnswer = useMemo(() => engine.getSurveyData().preview_answer, [
    engine
  ]);
  const { wording } = useSurveyConfig();

  if (previewAnswer) {
    return <PreviewAnswer className={styles.submit} />;
  }

  return (
    <PostAnswer
      className={styles.submit}
      label={wording.common.action.submit}
    />
  );
}
